import { useState, useEffect } from 'react'

export type Theme = 'light' | 'dark'

function getInitialTheme(): Theme {
  // Check if we're in a browser environment
  if (typeof window === 'undefined') return 'dark'

  // Check for saved theme preference first
  const savedTheme = localStorage.getItem('theme') as Theme | null
  if (savedTheme) return savedTheme

  // Fall back to system preference
  const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
  return prefersDark ? 'dark' : 'light'
}

export function useTheme() {
  const [theme, setTheme] = useState<Theme>(getInitialTheme)

  useEffect(() => {
    // Apply the initial theme immediately
    applyTheme(theme)
  }, [])

  const applyTheme = (newTheme: Theme) => {
    const root = document.documentElement
    if (newTheme === 'dark') {
      root.classList.add('dark')
    } else {
      root.classList.remove('dark')
    }
  }

  const toggleTheme = () => {
    const newTheme = theme === 'dark' ? 'light' : 'dark'
    setTheme(newTheme)
    applyTheme(newTheme)
    localStorage.setItem('theme', newTheme)
  }

  return { theme, toggleTheme }
}
